module.exports = __webpack_public_path__ + "img/icon_fn_scan_qr.272bf686.svg";